import React from 'react';
import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
export const GridColumn = props => {
  const {
    sm,
    md,
    lg,
    xl,
    xxl,
    xxxl,
    xlPush
  } = props;
  const gridColClassNames = classNames('ms-Grid-col', {
    ["ms-sm".concat(sm)]: !!sm
  }, {
    ["ms-md".concat(md)]: !!md
  }, {
    ["ms-lg".concat(lg)]: !!lg
  }, {
    ["ms-xl".concat(xl)]: !!xl
  }, {
    ["ms-xxl".concat(xxl)]: !!xxl
  }, {
    ["ms-xxxl".concat(xxxl)]: !!xxxl
  }, {
    ["ms-xlPush".concat(xlPush)]: !!xlPush
  });
  return /*#__PURE__*/_jsx("div", {
    className: gridColClassNames,
    style: props.styles,
    children: props.children
  });
};
GridColumn.defaultProps = {
  sm: 12
};